"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.assign");

var _slicedToArray = require("/app/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HorizontalMenu = void 0;

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var react_1 = require("react");

var icon_1 = tslib_1.__importDefault(require("antd/es/icon"));

var menu_1 = tslib_1.__importDefault(require("antd/es/menu"));

var MenuItem_1 = tslib_1.__importDefault(require("antd/es/menu/MenuItem"));

var SubMenu_1 = tslib_1.__importDefault(require("antd/es/menu/SubMenu"));

var SVG_1 = require("../SVG");

exports.HorizontalMenu = function (_a) {
  var updateLanguage = _a.updateLanguage,
      languages = _a.languages,
      mobileImg = _a.mobileImg,
      currentLanguage = _a.currentLanguage,
      children = _a.children,
      className = _a.className,
      leftOvers = tslib_1.__rest(_a, ["updateLanguage", "languages", "mobileImg", "currentLanguage", "children", "className"]);

  var classes = "clp-horizontal-menu ".concat(className ? className : '');

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isVisibleModal = _react_1$useState2[0],
      setIsVisibleModal = _react_1$useState2[1];

  var toggleModal = function toggleModal() {
    return setIsVisibleModal(function (prevState) {
      return !prevState;
    });
  };

  return React.createElement(React.Fragment, null, React.createElement(menu_1["default"], Object.assign({
    overflowedIndicator: React.createElement(icon_1["default"], {
      type: "menu",
      className: "icon-expand",
      onClick: toggleModal
    }),
    mode: "horizontal",
    className: classes
  }, leftOvers), children, React.createElement(menu_1["default"].SubMenu, {
    popupClassName: "clp-antd-submenu clp-antd-submenu_xs tt-u",
    key: "language",
    title: React.createElement("div", {
      className: "tt-u"
    }, currentLanguage, " ", React.createElement(SVG_1.SvgArrowLang, null))
  }, languages.map(function (item) {
    return React.createElement(menu_1["default"].Item, {
      onClick: function onClick() {
        return updateLanguage(item);
      },
      key: item
    }, item);
  }))), isVisibleModal && React.createElement("div", {
    className: "clp-sub-menu"
  }, React.createElement("img", {
    src: mobileImg,
    alt: "mobile menu",
    className: "clp-sub-menu__img"
  }), React.createElement(menu_1["default"], Object.assign({}, leftOvers, {
    mode: "inline",
    onClick: toggleModal
  }), React.createElement(MenuItem_1["default"], null, React.createElement(SVG_1.SvgClose, null)), children, React.createElement(SubMenu_1["default"], {
    key: "language",
    title: currentLanguage,
    className: "submenu_transparent tt-u",
    popupClassName: "tt-u"
  }, languages.map(function (item) {
    return React.createElement(menu_1["default"].Item, {
      className: item === currentLanguage ? 't_bold' : 't_normal',
      onClick: function onClick() {
        return updateLanguage(item);
      },
      key: item
    }, item);
  })))));
};